export const types = {
    SET_GET_CAMPAIGN: '[CAMPAIGN] SET GET CAMPAIGN',
    SET_GET_CAMPAIGN_BY_ID: '[CAMPAIGN] SET GET CAMPAIGN BY ID'
}